import React, { useState } from 'react';
import EdiDashboard from './EdiDashboard';
import type { EdiView } from './EdiDashboard';
import BatchesView from './BatchesView';
import ExceptionsView from './ExceptionsView';
import DeadlineBoard from './DeadlineBoard';
import EnrollmentStatus from './EnrollmentStatus';
import { EdiGate } from './ediUi';

const VIEWS: Array<{ key: EdiView; label: string }> = [
  { key: 'dashboard', label: 'Dashboard' },
  { key: 'batches', label: 'Batches' },
  { key: 'exceptions', label: 'Exceptions' },
  { key: 'deadlines', label: 'Deadlines' },
  { key: 'enrollment', label: 'Enrollment' },
];

/** Pelora Billing tab of Billing home (Phase 22 R1): dashboard, batches, exceptions, deadlines, enrollment. */
const EdiWorkspaceInner: React.FC<{ initialView?: EdiView }> = ({ initialView = 'dashboard' }) => {
  const [view, setView] = useState<EdiView>(initialView);
  const [itemId, setItemId] = useState<string | null>(null);

  const navigate = (next: EdiView, id?: string) => {
    setItemId(next === 'exceptions' && id ? id : null);
    setView(next);
  };

  return (
    <div className="rounded bg-white shadow">
      <div className="flex flex-wrap gap-1 border-b border-slate-100 px-2 pt-3 sm:px-4" role="tablist" aria-label="Pelora Billing">
        {VIEWS.map((v) => (
          <button
            key={v.key}
            type="button"
            role="tab"
            aria-selected={view === v.key}
            onClick={() => navigate(v.key)}
            className={`shrink-0 rounded-t-md px-3 py-1.5 text-sm font-medium ${view === v.key ? 'border-b-2 border-slate-800 text-slate-900' : 'text-slate-500 hover:text-slate-800'}`}
          >
            {v.label}
          </button>
        ))}
      </div>
      <div role="tabpanel">
        {view === 'dashboard' && <EdiDashboard onNavigate={navigate} />}
        {view === 'batches' && <BatchesView />}
        {view === 'exceptions' && <ExceptionsView key={itemId || 'list'} initialItemId={itemId} />}
        {view === 'deadlines' && <DeadlineBoard />}
        {view === 'enrollment' && <EnrollmentStatus />}
      </div>
    </div>
  );
};

const EdiWorkspace: React.FC<{ initialView?: EdiView }> = (props) => (
  <EdiGate>
    <EdiWorkspaceInner {...props} />
  </EdiGate>
);

export default EdiWorkspace;
